export default __webpack_public_path__ + "static/prometheus-7e92e55d9b5535c1d0e0b1fea6e33743.png";